module.exports = __webpack_public_path__ + "static/media/do-recyklingu.83d055b5.svg";